module.exports = __webpack_public_path__ + "images/verified-broadcaster-5db240b952177df40e67b3d002bcb145.png";